.sidebar {
    width: 260px;
    flex: 0 0 260px;
    display: flex;
    flex-direction: column;
    max-height: 1024px; /* matches Chat.module.css .chatMessageStream so both scroll internally, not the page */
    border-right: 1px solid rgb(237, 235, 233);
    background: rgba(255, 255, 255, 0.6);
}

.newChatButton {
    margin: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid rgb(200, 198, 196);
    background: white;
    font-family: monospace;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
    flex: 0 0 auto;
}

.newChatButton:hover {
    background: rgb(243, 242, 241);
}

.list {
    flex: 1;
    min-height: 0; /* without this a flex item won't shrink below its content height, so it never scrolls */
    overflow-y: auto;
    padding: 0 8px 12px;
}

.item {
    display: block;
    width: 100%;
    padding: 10px 10px;
    margin-bottom: 2px;
    border: none;
    border-radius: 6px;
    background: transparent;
    text-align: left;
    font-family: monospace;
    font-size: 12px;
    color: rgb(50, 49, 48);
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item:hover {
    background: rgb(243, 242, 241);
}

.itemActive {
    background: rgb(232, 229, 249);
    font-weight: 600;
}

.emptyState {
    padding: 12px;
    font-size: 12px;
    color: rgb(96, 94, 92);
    font-family: monospace;
}
